import { IcInfoFilled16 } from '@assets/icons/16x16';
import { Center, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { Tooltip } from '@components/ui/tooltip';
import { addPrefix } from '@utils/common.utils';
import { memo, ReactElement } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

type ValueType =
  | {
      value: ReactElement;
      isEmpty?: boolean;
    }
  | {
      value: string | number | undefined | null;
      isEmpty?: never;
    };

type Props = {
  label: string;
  infoLabel?: string;
  prefix?: 'last' | 'max' | null;
  showTooltip?: boolean;
} & ValueType;

function InfoValue({ label, value, showTooltip = false, infoLabel, isEmpty = false, prefix = null }: Readonly<Props>) {
  const { formatMessage } = useIntl();
  const isReactElement =
    typeof value !== 'string' && typeof value !== 'number' && value !== undefined && value !== null;

  const prefixLabel = prefix ? formatMessage({ id: `global.${prefix}` }) : null;

  return (
    <VStack width="100%" gap="tightL" alignItems="start" cursor="default">
      <HStack gap={1} justifyContent="center">
        <Text textStyle="screenStd" color="neutral.300">
          {label}
        </Text>
        {infoLabel && (
          <Tooltip
            content={infoLabel}
            positioning={{
              placement: 'top',
            }}
          >
            <Center>
              <Icon as={IcInfoFilled16} color="neutral.300" />
            </Center>
          </Tooltip>
        )}
      </HStack>
      <Tooltip disabled={!showTooltip} content={value}>
        {isReactElement && !isEmpty ? (
          value
        ) : (
          <Text textStyle="screenStd" fontWeight="medium" lineClamp={2} wordBreak="break-all">
            {isEmpty || value === null || value === undefined ? (
              <FormattedMessage id="global.NA" />
            ) : (
              addPrefix(value as string | number, prefixLabel)
            )}
          </Text>
        )}
      </Tooltip>
    </VStack>
  );
}

export default memo(InfoValue);
